module.exports = __webpack_public_path__ + "img/light-red.07e35da0.jpg";